import Moment from "moment";
import $ from 'jquery';

export default class Helper {
	static autoFormatSize(sizeInKB) {
		const KB = sizeInKB;
		const MB = KB / 1000;
		const GB = MB / 1000;
		const TB = GB / 1000;

		if (TB >= 1) return TB.toFixed(2) + ' TB';
		if (GB >= 1) return GB.toFixed(2) + ' GB';
		if (MB >= 1) return MB.toFixed(2) + ' MB';
		return KB.toFixed(2) + ' KB';
	}

	static closeKeyboardBtn(id) {
		let closeBtn = document.getElementById(id);
		document.addEventListener("keypress", (event) => {
			let keyCode = event.keyCode ? event.keyCode : event.which;

			if (keyCode === 27) {
				closeBtn.click();
			}
		});
	}

	static changeLabelWorkLayer(value) {
		switch (value) {
			case "R01":
				return "Maintenance";
			case "R02":
				return "R02 Road Shoulder";
			case "R03":
				return "R03 Grass Cutting";
			case "R04":
				return "R04 Road Furniture";
			case "R05":
				return "R05 Bridges, Pedestrian Crossing & Culverts";
			case "R06":
				return "R06 Road Line Marking";
			case "R07":
				return "R07 Drainage";
			case "R08":
				return "R08 Road Cleaning";
			case "R09":
				return "Inspection";
			case "R10":
				return "R10 Mandatory Inspection";
			case "KKE":
				return "Electric";
			case "All":
				return "All";
		}
	}
	static showTooltip(e) {
		if (e && e.target) {
			$(e.target).tooltip('show');
		}

		return;
	}
	static hideTooltip(e) {
		if (e && e.target) {
			$(e.target).tooltip('hide');
		}

		return;
	}

	static workCategories() {
		return ["Rutin", "Berkala_Pavemen", "Berkala_Bukan_Pavemen", "Kecemasan", "Agensi_Berkenaan"];
	}

	static formatGeojsonName(name) {
		if (name) {
			let newName = name.replace(".geojson", "");

			return newName.split("_").join(" ");
		} else {
			return "";
		}
	}

	static colors(value) {
		const clr = {
			aqua: "#00ffff",
			beige: "#f5f5dc",
			brown: "#a52a2a",
			darkblue: "#00008b",
			darkcyan: "#008b8b",
			darkgreen: "#006400",
			darkkhaki: "#bdb76b",
			darkmagenta: "#8b008b",
			darkorange: "#ff8c00",
			darkred: "#8b0000",
			darksalmon: "#e9967a",
			darkviolet: "#9400d3",
			fuchsia: "#ff00ff",
			gold: "#ffd700",
			green: "#008000",
			indigo: "#4b0082",
			khaki: "#f0e68c",
			lightblue: "#add8e6",
			lightcyan: "#e0ffff",
			lightgreen: "#90ee90",
			lightgrey: "#d3d3d3",
			lightpink: "#ffb6c1",
			lightyellow: "#ffffe0",
			lime: "#00ff00",
			magenta: "#ff00ff",
			maroon: "#800000",
			navy: "#000080",
			olive: "#808000",
			orange: "#ffa500",
			darkorchid: "#9932cc",
			pink: "#ffc0cb",
			cyan: "#00ffff",
			darkolivegreen: "#556b2f",
			purple: "#800080",
			violet: "#800080",
			darkgrey: "#a9a9a9",
			red: "#ff0000",
			silver: "#c0c0c0",
			white: "#ffffff",
			yellow: "#ffff00",
			blue: "#0000ff",
			azure: "#f0ffff"
		}

		const name = value < Object.keys(clr).length ? Object.keys(clr)[value] : Object.keys(clr)[value - Object.keys(clr).length];

		return clr[name];
	}

	static titleCase(text) {
		return text.replace(/([a-z])([A-Z])/g, '$1 $2');
	}

	static snakeToTitleCase(text) {
		let result = text.split("_");

		result = result.map(t => t[0].toUpperCase().concat(t.substring(1, t.length))).join(" ");

		return result;
	}

	static generateCaseNumber(id) {
		let retVal = id.replace(/\D/g, '');
		return retVal.substring(retVal.length - 6);
	}

	static formatDate(date, noTime) {
		if (!date) {
			return "";
		} else {
			let format = noTime ? "D MMM YYYY" : "D MMM YYYY, h:mm A"
			return !Number.isNaN(date) && (date.toString().length == 10 || date.toString().length == 13) ? Moment.unix(parseInt(date)).format(format) : Moment(date).format(format);
		}
	}

	static formatMediaUrl(media) {
		if (media && media.url) {
			let url = media.url;

			return url.startsWith("http") ? url : `https://${url}`;
		} else {
			return false;
		}
	}

	static formatCoordinate(coord) {
		if (coord && coord.length == 2) {
			return `${parseFloat(coord[0]).toFixed(6)}, ${parseFloat(coord[1]).toFixed(6)}`;
		} else if (coord && coord.length == 1) {
			return `${parseFloat(coord[0]).toFixed(6)}`;
		} else {
			return "";
		}
	}

	static getRoadInfo(road, breakLine) {
		if (!road) {
			return "";
		}

		let result = [];

		if (road.name) {
			result.push(road.name);
		}

		if (road.subdistrict) {
			result.push(road.subdistrict);
		}

		if (road.district) {
			result.push(road.district);
		}

		return result.join(breakLine ? "<br />" : ", ");
	}

	static socialMediaIcons(type) {
		const icons = {
			facebook: {
				i: ["fab", "facebook-square"],
				color: "facebook"
			},
			twitter: {
				i: ["fab", "twitter"],
				color: "twitter"
			},
			waze: {
				i: ["fab", "waze"],
				color: "waze"
			},
			instagram: {
				i: ["fab", "instagram"],
				color: "instagram"
			},
			mobile: {
				i: ["fas", "mobile-alt"],
				color: "dark"
			},
			ai: {
				i: ["fas", "video"],
				color: "dark"
			},
			textMessage: {
				i: ["far", "comment-dots"],
				color: "info"
			},
			others: {
				i: ["fas", "comment-alt"],
				color: "light"
			}
		}

		const result = icons[type];

		return result ? result : icons.others;
	}

	static colorPalettes = [
		"#ecdd7b",
		"#8f3bb3",
		"#bfdbf7",
		"#9d858d",
		"#776871",
		"#5c7457",
		"#eee1b3",
		"#dbad6a",
		"#cf995f",
		"#d0ce7c",
		"#b09e99",
		"#fee9e1",
		"#fad4c0",
		"#64b6ac",
		"#c0fdfb",
		"#5efc8d",
		"#8ef9f3",
		"#4c5760",
		"#01fdf6",
		"#03fcba"
	]
}
